import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue, get, remove, push, off, } from "firebase/database";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, } from "firebase/auth";
let app;
let db;
export function configureDatabase() {
    const firebaseConfig = {
        apiKey: "AIzaSyCXvla1Om6czFgk7moO3CDRCYsoLc7iFuQ",
        authDomain: "cedar-park-church-slides.firebaseapp.com",
        databaseURL: "https://cedar-park-church-slides-default-rtdb.firebaseio.com",
        projectId: "cedar-park-church-slides",
        storageBucket: "cedar-park-church-slides.appspot.com",
        messagingSenderId: "781686075172",
        appId: "1:781686075172:web:bbd683c13c9efb0ad70db1",
    };
    // Initialize Firebase
    app = initializeApp(firebaseConfig);
    db = getDatabase(app);
}
export function database() {
    return db;
}
export function dataRef(dbRef) {
    if (typeof dbRef === "string") {
        dbRef = ref(db, dbRef);
    }
    return dbRef;
}
export function dataOnce(dbRef) {
    return get(dataRef(dbRef)).then((snapshot) => {
        return snapshot.val();
    });
}
export function dataOn(dbRef, callback) {
    onValue(dataRef(dbRef), (snapshot) => {
        callback(snapshot.val());
    });
}
export function dataOff(dbRef) {
    return off(dataRef(dbRef));
}
export function dataSet(dbRef, data) {
    return set(dataRef(dbRef), data);
}
export function dataDelete(dbRef) {
    return remove(dataRef(dbRef));
}
export function dataPush(parent, value) {
    return push(dataRef(parent), value);
}
export function dataGetAuth() {
    return getAuth(app);
}
export function dataOnAuthStateChanged(nextOrObserver, error, completed) {
    return onAuthStateChanged(dataGetAuth(), nextOrObserver, error, completed);
}
export function dataSignInWithEmailAndPassword(username, passkey) {
    console.log("dataSignInWithEmailAndPassword");
    return signInWithEmailAndPassword(dataGetAuth(), username, passkey);
}
